import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { AppController } from './app.controller';
import { AppService } from './app.service';
import { Attendance } from './attendance/attendance.entity';
import { AttendanceModule } from './attendance/attendance.module';
import { Projects } from './projects/projects.entity';
import { ProjectsModule } from './projects/projects.module';
import { States } from './states/states.entity';
import { StatesModule } from './states/states.module';
import { CostCentersModule } from './cost-centers/cost-centers.module';
import { CostCenters } from './cost-centers/cost-centers.entity';
import { EmployeeDetailsModule } from './employee-details/employee-details.module';
import { EmployeeDetails } from './employee-details/employee-details.entity';
import { SubContractors } from './sub-contractors/sub-contractors.entity';
import { SubContractorsModule } from './sub-contractors/sub-contractors.module';
import { ProjectMappingModule } from './project-mapping/project-mapping.module';
import { ProjectMapping } from './project-mapping/project-mapping.entity';
import { HolidaysController } from './holidays/holidays.controller';
import { HolidaysModule } from './holidays/holidays.module';
import { Holidays } from './holidays/holidays.entity'
import { PassportModule} from './passport/passport.module'
import { AuthModule } from './auth/auth.module';
import { UserModule } from './user/user.module';
import {UserEntity} from './user/user.entity';
// import { UsersService } from './users/users.service';
import { EmploymentTypeModule } from './employment-type/employment-type.module';
import { EmploymentType } from './employment-type/employment-type.entity';
import {EmploymentModeEnum,EmployeeTerminationApprovalStatus,RolesList,Gender,MaritalStatus} from '@gtpl/shared-models/gtpl';
import { DesignationsModule } from './designations/designations.module';
import { Designations } from './designations/designations.entity';
import { SubContractorsPaymentsModule } from './sub-contractors-payments/sub-contractors-payments.module';
import { SubContractorsPayments } from './sub-contractors-payments/sub-contractors-payments.entity';
import { AttendanceService } from './attendance/attendance.service';
import { ScheduleModule } from '@nestjs/schedule';
import { Logs } from './logs/logs.entity';
import { LogsModule } from './logs/logs.module';
// import { BotService } from './bot/bot.service';
import { EmployeeCashbookModule } from './employee-cashbook/employee-cashbook.module';
import { EmployeeCashbook } from './employee-cashbook/employee-cashbook.entity';
import { LoansModule } from './loans/loans.module';
import { BranchesModule } from './branches/branches.module';
import { ReceiptsModule } from './receipts/receipts.module';
import { PaymentGatewayModule } from './payment-gateway/payment-gateway.module';
import { Donors } from './donors/donor.entity';
import { DonorsModule } from './donors/donor.module';
@Module({
  imports: [ 
    
    TypeOrmModule.forRoot({
    type: 'mysql',
    host: '206.189.138.212',
    // host: 'localhost',
    port: 3306,
    username: 'sa_dev_user',
    password: 'R@ms1905',
    database: 'finance',
    entities: [States,Projects,CostCenters,Attendance,SubContractors,ProjectMapping,Holidays,UserEntity,EmployeeDetails,EmploymentType,Designations,SubContractorsPayments,Logs,EmployeeCashbook,Donors],
    synchronize: false,
    logging: true
  }), 
  ScheduleModule.forRoot(),
  // DesignationsModule,StatesModule, CostCentersModule,AttendanceModule,
  // SubContractorsModule, HolidaysModule, SubContractorsPaymentsModule,ProjectsModule,EmployeeDetailsModule, EmploymentTypeModule,
  AuthModule, UserModule,PassportModule,
  LogsModule, LoansModule, BranchesModule, ReceiptsModule, PaymentGatewayModule,DonorsModule],
  controllers: [AppController],
  providers: [AppService],
})
export class AppModule {}
